module.exports = __webpack_public_path__ + "static/media/15fd460a-a813-4ac0-9c0f-9d9a8ffb0f01_1.755e6f2921f93709351a8fba6dc5953e.b724e658.jpeg";